// src/components/pages/OrderSuccess.jsx
import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { getColors } from '../../styles/colors';
import { FaCheck, FaHome, FaReceipt, FaShoppingBag } from 'react-icons/fa';
import { motion } from 'framer-motion';

const OrderSuccess = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const theme = useSelector((state) => state.theme?.mode || 'light');
  const isDark = theme === 'dark';
  const colors = getColors(isDark);
  
  const { orderId, orderNumber, totalAmount } = location.state || {};

  useEffect(() => {
    if (!orderId && !orderNumber) {
      // If no order data, redirect to home
      setTimeout(() => navigate('/'), 3000);
    }
  }, [orderId, orderNumber, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center px-4" style={{ backgroundColor: colors.background }}>
      <motion.div
        initial={{ scale: 0.8, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{ duration: 0.5 }}
        className="rounded-2xl p-8 max-w-md w-full text-center"
        style={{ 
          backgroundColor: colors.card,
          border: `1px solid ${colors.border}`
        }}
      >
        <div className="w-24 h-24 rounded-full flex items-center justify-center mx-auto mb-6"
             style={{ backgroundColor: '#22C55E20' }}>
          <FaCheck className="text-5xl" style={{ color: '#22C55E' }} />
        </div>
        
        <h1 className="text-3xl font-bold mb-2" style={{ color: colors.text }}>
          Order Placed! 🎉
        </h1>
        <p className="text-sm mb-6" style={{ color: colors.textSecondary }}>
          Thank you for your order. We'll notify you when it's ready.
        </p>
        
        <div className="space-y-3 text-left mb-6 p-4 rounded-xl" style={{ backgroundColor: colors.inputBackground }}>
          {orderNumber && (
            <div className="flex justify-between">
              <span className="text-sm" style={{ color: colors.textSecondary }}>Order Number</span>
              <span className="text-sm font-semibold" style={{ color: colors.text }}>{orderNumber}</span>
            </div>
          )}
          {orderId && (
            <div className="flex justify-between">
              <span className="text-sm" style={{ color: colors.textSecondary }}>Order ID</span>
              <span className="text-sm font-semibold" style={{ color: colors.text }}>#{orderId}</span>
            </div>
          )}
          {totalAmount && (
            <div className="flex justify-between">
              <span className="text-sm" style={{ color: colors.textSecondary }}>Total Amount</span>
              <span className="text-sm font-semibold" style={{ color: colors.primary }}>₹{totalAmount}</span>
            </div>
          )}
          <div className="flex justify-between">
            <span className="text-sm" style={{ color: colors.textSecondary }}>Payment Method</span>
            <span className="text-sm font-semibold" style={{ color: colors.text }}>Cash on Delivery</span>
          </div>
          <div className="flex justify-between">
            <span className="text-sm" style={{ color: colors.textSecondary }}>Status</span>
            <span className="text-sm font-semibold text-green-500">Confirmed</span>
          </div>
        </div>
        
        <div className="flex flex-col gap-3">
          <button
            onClick={() => navigate('/my-orders')}
            className="w-full py-3 rounded-xl font-semibold text-white transition-all hover:scale-[1.02] flex items-center justify-center gap-2"
            style={{ backgroundColor: colors.primary }}
          >
            <FaReceipt /> View Orders
          </button>
          <button
            onClick={() => navigate('/')}
            className="w-full py-3 rounded-xl font-medium transition-all hover:scale-[1.02] flex items-center justify-center gap-2"
            style={{ 
              backgroundColor: colors.inputBackground,
              color: colors.text,
              border: `1px solid ${colors.border}`
            }}
          >
            <FaHome /> Home
          </button>
        </div>
      </motion.div>
    </div>
  );
};

export default OrderSuccess;